import React from 'react';

import cn from 'classnames';
import { MdFilterList } from 'react-icons/md';

import Button from '../Button';
import styles from './FilterButton.less';

const FilterButton = ({
  children,
  className,
  rightPadding = false,
  icon = <MdFilterList />,
  ...rest
}: {
  children?: React.ReactElement;
  className?: string;
  rightPadding?: boolean;
  icon?: JSX.Element;
}) => {
  const classNames = cn(className, {
    [styles.noRightPadding]: !rightPadding,
  });

  return (
    <Button
      ghost
      noBorder
      fitText
      color="white"
      className={classNames}
      uppercase={false}
      icon={icon}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default FilterButton;
